import type { ReactNode } from 'react';

/**
 * Static label pill (non-interactive). Use Chip for toggleable filters.
 *
 *   <Pill tone="sage">Free consult</Pill>
 *   <Pill tone="ember">Verified</Pill>
 */

export type PillTone = 'ink' | 'ember' | 'sage' | 'gold' | 'muted';

export interface PillProps {
    tone?: PillTone;
    children: ReactNode;
    className?: string;
}

const TONE_CLASSES: Record<PillTone, string> = {
    ink: 'bg-ink text-paper',
    ember: 'bg-ember-tint text-ember-deep',
    sage: 'bg-sage-tint text-sage',
    gold: 'bg-amber-100 text-amber-900',
    muted: 'bg-paper-deep text-ink-soft',
};

export function Pill({ tone = 'ink', children, className }: PillProps) {
    const cls = [
        'inline-flex items-center px-2 py-0.5 text-[11px] font-medium tracking-wide uppercase rounded-full',
        TONE_CLASSES[tone],
        className ?? '',
    ]
        .filter(Boolean)
        .join(' ');

    return <span className={cls}>{children}</span>;
}

export default Pill;
